import React, { useState, useRef, useEffect } from "react";

const Categories = ({
  filters,
  activeFilters,
  handleFilters,
  translations,
}) => {
  const [activeCertDropdown, setActiveCertDropdown] = useState(false);
  const [activeProductDropdown, setActiveProductDropdown] = useState(false);

  const productTranslation = translations?.find(
    (translation) => translation.Key === "Products"
  );
  const certTranslation = translations?.find(
    (translation) => translation.Key === "Certificates"
  );
  const statementsTranslation = translations?.find(
    (translation) => translation.Key === "Statements"
  );

  //Get translations for dropdown
  const getTranslation = (key) => {
    const t = translations?.find((translation) => translation.Key === key);
    return t.Translation;
  };

  //Close dropdowns when clicking outside
  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setActiveCertDropdown(false);
        setActiveProductDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="container list-page-new__filter_container" ref={ref}>
      <div className="filter-selector">
        <div
          className={
            activeProductDropdown
              ? "filter_text display_subc chevron-up"
              : "filter_text"
          }
        >
          <span
            className="click_categories"
            onClick={() => setActiveProductDropdown(!activeProductDropdown)}
          >
            {productTranslation?.Translation}
          </span>
          <div className="sub_categories_container">
            <div className="checkbox_categories">
              {filters?.Products &&
                filters.Products.map((products, index) => (
                  <React.Fragment key={index}>
                    <h6>{products.Group}</h6>
                    {products.Products.map((product) => (
                      <label className="checkbox_container" key={product.Name}>
                        {product.Name}
                        <input
                          type="checkbox"
                          value={product.Name}
                          checked={activeFilters.some(
                            (filter) => filter === product
                          )}
                          onChange={() => handleFilters(product)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    ))}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="filter-selector">
        <div
          className={
            activeCertDropdown
              ? "filter_text display_subc chevron-up"
              : "filter_text"
          }
        >
          <span
            className="click_categories"
            onClick={() => setActiveCertDropdown(!activeCertDropdown)}
          >
            {certTranslation?.Translation} &{" "}
            {statementsTranslation?.Translation}
          </span>
          <div className="sub_categories_container">
            <div className="checkbox_categories">
              {filters?.CertificatesAndStatements &&
                Object.entries(filters?.CertificatesAndStatements).map(
                  ([key, values]) => (
                    <div key={key}>
                      <h6>{getTranslation(key)}</h6>
                      {values.map((item) => (
                        <label className="checkbox_container" key={item.ID}>
                          {item.CertificateName ||
                            item.StatementName ||
                            item.OtherName}
                          <input
                            type="checkbox"
                            value={
                              item.CertificateName ||
                              item.StatementName ||
                              item.OtherName
                            }
                            checked={activeFilters.some(
                              (filter) => filter === item
                            )}
                            onChange={() => handleFilters(item)}
                          />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                    </div>
                  )
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
